<div class="employee-workspace__schedule">
  @if(loading()){<p role="status">{{'workforceV2.planning.loading'|translate}}</p>}
  @if(error()){<p role="alert">{{'workforceCutover.failed'|translate}}</p>}
  @if(changed()){<p>{{'workforceCutover.publishPeriod'|translate}}</p>}
  <article class="employee-card employee-card--full">
    <div class="employee-workspace__view-toolbar employee-schedule__toolbar">
      <div class="employee-workspace__view-period employee-schedule__period">
        <span>{{ 'users.workspace.tabs.schedule' | translate }}</span>
        <strong>{{ scheduleWeekVm().periodLabel }}</strong>
      </div>

      <div class="employee-workspace__view-controls employee-schedule__controls">
        <div class="employee-workspace__nav-group">
          <button class="employee-text-action"
            type="button"
            (click)="previousWeek()">
            <ion-icon name="chevron-back-outline"></ion-icon>
            <span class="sr-only">{{ 'users.workspace.actions.previous' | translate }}</span>
          </button>
          <button class="employee-workspace__control employee-workspace__control--text"
            type="button"
            (click)="goToCurrentWeek()">
            <span>{{ 'users.workspace.actions.today' | translate }}</span>
          </button>
          <button class="employee-text-action"
            type="button"
            (click)="nextWeek()">
            <span class="sr-only">{{ 'users.workspace.actions.next' | translate }}</span>
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="employee-schedule__summary">
      <div class="employee-schedule__summary-chip">
        <span>{{ 'users.workspace.schedule.summary.shifts' | translate }}</span>
        <strong>{{ scheduleWeekVm().shiftsCount }}</strong>
      </div>
      <div class="employee-schedule__summary-chip">
        <span>{{ 'users.workspace.schedule.summary.hours' | translate }}</span>
        <strong>{{ scheduleWeekVm().hoursLabel }}</strong>
      </div>
      <div class="employee-schedule__summary-chip">
        <span>{{ 'users.workspace.labels.nextShift' | translate }}</span>
        <strong>{{ scheduleWeekVm().nextShiftLabel }}</strong>
      </div>
    </div>
  </article>

  @if (!scheduleWeekVm().hasAnyShifts) {
    <article class="employee-card employee-card--full">
      <div class="employee-card__header">
        <h2>{{ 'users.workspace.schedule.empty.title' | translate }}</h2>
        <p>{{ 'users.workspace.schedule.empty.description' | translate }}</p>
      </div>
      <div class="employee-empty-state">
        {{ 'users.workspace.schedule.empty.body' | translate }}
      </div>
    </article>
  }
    <div class="employee-workspace__split-layout employee-schedule__content">
      <div class="employee-workspace__split-main">
        <div class="employee-schedule__grid">
          @for (day of scheduleWeekVm().days; track day.iso) {
            <div class="employee-day"
              [class.employee-day--today]="day.isToday"
              [class.employee-day--weekend]="day.isWeekend">
              <header class="employee-day__header">
                <strong>{{ day.label }}</strong>
                <span>{{ day.shortDate }}</span>
              </header>

              <div class="employee-day__body">
                @for (shift of day.shifts; track shift.id) {
                  <button class="employee-shift"
                    type="button"
                    [class.employee-shift--selected]="selectedShiftId() === shift.id"
                    (click)="selectShift(shift.id)">
                    <strong>{{ shift.timeLabel }}</strong>
                    <span>{{ shift.siteName }}</span>
                    <small>{{ shift.durationLabel }}</small>
                  </button>
                } @empty {
                  @if(!day.actual.length){<div class="employee-day__empty">{{ 'users.workspace.schedule.empty.day' | translate }}</div>}
                }

                @for(actual of day.actual;track actual.id){
                  <button type="button"
                    [class]="day.shifts.length ? 'employee-text-action employee-day__actual' : 'employee-shift employee-shift--actual'"
                    [class.employee-shift--selected]="selectedActualId() === actual.id"
                    [attr.aria-pressed]="selectedActualId() === actual.id"
                    (click)="selectActual(actual.id)">
                    <strong>{{ 'employeeV2.milestone.actual' | translate }} {{ actual.minutes | employeeDuration }}</strong>
                    <span>{{ actual.siteName }}</span>
                    @if(actual.start !== '—' || actual.end !== '—'){<small>{{ actual.start }} – {{ actual.end }}</small>}
                    @if(!day.shifts.length){<small>{{ 'employeeV2.milestone.noPlannedShift' | translate }}</small>}
                  </button>
                }

                @if(canManage()){<button class="employee-day__add"
                  type="button"
                  (click)="addShiftForDay(day.date)">
                  <ion-icon name="add-outline"></ion-icon>
                  <span>{{ 'users.workspace.schedule.actions.addShift' | translate }}</span>
                </button>}
              </div>
            </div>
          }
        </div>
      </div>

      <article class="employee-card employee-card--schedule-detail employee-workspace__split-aside">
        <div class="employee-card__header">
          <div class="employee-card__header-row">
            <div>
              <h2>{{ (selectedActual() ? 'employeeV2.milestone.actual' : 'users.workspace.schedule.detail.title') | translate }}</h2>
              @if(!selectedActual()){<p>{{ 'users.workspace.schedule.detail.description' | translate }}</p>}
            </div>

            @if (selectedShift() && canManage()) {
              <button class="employee-text-action employee-text-action--danger"
                type="button"
                [disabled]="busy() || loading()" (click)="removeSelectedShift()">
                <ion-icon name="trash-outline"></ion-icon>
                <span>{{ 'users.workspace.schedule.actions.deleteShift' | translate }}</span>
              </button>
            }
          </div>
        </div>

        @if(selectedActual();as actual){
          <div class="employee-card__details employee-card__details--summary">
            <div><span>{{ 'users.workspace.schedule.detail.labels.day' | translate }}</span><strong>{{ actual.date | date:'d.M.yyyy' }}</strong></div>
            <div><span>{{ 'users.workspace.schedule.detail.labels.site' | translate }}</span><strong>{{ actual.siteName }}</strong></div>
            @if(actual.projectId){<div><span>{{ 'workforceV2.project' | translate }}</span><strong>{{ actualProjectName() }}</strong></div>}
            <div><span>{{ 'users.workspace.schedule.detail.labels.time' | translate }}</span><strong>{{ actual.start }} – {{ actual.end }}</strong></div>
            <div><span>{{ 'users.workspace.schedule.detail.labels.duration' | translate }}</span><strong>{{ actual.minutes | employeeDuration }}</strong></div>
            <div><span>{{ 'workforceV2.status' | translate }}</span><strong>{{ actual.statusLabel | translate }}</strong></div>
            <div><span>{{ 'users.workspace.schedule.detail.labels.notes' | translate }}</span><strong>{{ actual.note }}</strong></div>
          </div>
        } @else if (selectedShift(); as selectedShift) {
          <div class="employee-card__details employee-card__details--summary">
            <div>
              <span>{{ 'users.workspace.schedule.detail.labels.day' | translate }}</span>
              <strong>{{ selectedShift.dateLabel }}</strong>
            </div>
            <div>
              <span>{{ 'users.workspace.schedule.detail.labels.time' | translate }}</span>
              <strong>{{ selectedShift.timeLabel }}</strong>
            </div>
            <div>
              <span>{{ 'users.workspace.schedule.detail.labels.site' | translate }}</span>
              <strong>{{ selectedShift.siteName }}</strong>
            </div>
            <div>
              <span>{{ 'users.workspace.schedule.detail.labels.team' | translate }}</span>
              <strong>{{ selectedShift.teamLabel }}</strong>
            </div>
            <div>
              <span>{{ 'users.workspace.schedule.detail.labels.area' | translate }}</span>
              <strong>{{ selectedShift.workTypeLabel }}</strong>
            </div>
            <div>
              <span>{{ 'users.workspace.schedule.detail.labels.duration' | translate }}</span>
              <strong>{{ selectedShift.durationLabel }}</strong>
            </div>
            <div>
              <span>{{ 'users.workspace.schedule.detail.labels.notes' | translate }}</span>
              <strong>{{ selectedShift.notes }}</strong>
            </div>
          </div>
        } @else {
          <div class="employee-empty-state">
            {{ 'users.workspace.schedule.detail.empty' | translate }}
          </div>
        }
      </article>
    </div>
</div>

<ion-modal [isOpen]="!!editorDate()" (didDismiss)="editorDate.set(null)" class="stack-modal"><ng-template>
  <app-modal-shell (dismiss)="editorDate.set(null)"><h2 modalTitle>{{'users.workspace.schedule.actions.addShift'|translate}}</h2>
    @if(editorDate();as date){<app-workforce-planning-panel [employee]="user().guid" [selectedDate]="date" (changed)="saved()"/>}
  </app-modal-shell>
</ng-template></ion-modal>
